
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-54278734&scoped=true!sass-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./statement.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./statement.js"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-54278734!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./statement.vue"),
  /* scopeId */
  "data-v-54278734",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/account/statement.vue
// module id = 1948
// module chunks = 1